/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_SuspendInputs */

const cs_franchise_suspend = /** @type {(inputs: Franchise_SuspendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozastavit licenci`)
};

const en_franchise_suspend = /** @type {(inputs: Franchise_SuspendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspend license`)
};

/**
* | output |
* | --- |
* | "Suspend license" |
*
* @param {Franchise_SuspendInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_suspend = /** @type {((inputs?: Franchise_SuspendInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_SuspendInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_suspend(inputs)
	return cs_franchise_suspend(inputs)
});